class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form')
    this.atc = this.querySelector('[type="submit"]')
  }

  async handleSubmit(e) {
    e.preventDefault()

    this.atc.setAttribute('disabled', '')
    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.show) {
        Rebuy.SmartCart.show();
      }
    })
    .catch(error => {
      console.error('Add to cart failed', error);
    })
    this.atc.removeAttribute('disabled')
  }
}

customElements.define('product-card', ProductCard);


Array.from(document.querySelectorAll('.product-card-video-loop')).forEach(video => {
  if (window.innerWidth > 767) {
    video.addEventListener("mouseenter", function () {
      try {
        video.play()
      } catch (error) {

      }
    })
    video.addEventListener("mouseleave", function () {
      video.loop = false
    })
  } else {
    try {
      video.play()
    } catch (error) {

    }
  }
})

Array.from(document.querySelectorAll('.product-accordion .accordion-item')).forEach(item => {
    item.addEventListener('click', (e) => {
        const itemBody = item.querySelector('.accordion-item-body');
        if (e.target != itemBody) {
            item.classList.toggle("opened");    
        }
    })
})

window.handleQtybox = function(wrapper, e) {
  const input = wrapper.querySelector('input')
  const value = Number(input.value)

  if (e.target.classList.contains('qtyminus')) input.value = Math.max(value - 1, 1)
  else if (e.target.classList.contains('qtyplus')) input.value = value + 1
}
